<template>
  <div>
    <!-- Testata -->
    <v-expansion-panel flat class="has-border-bottom" v-model="panelTestata" style="padding: 0px !important">
      <v-expansion-panel-content style="background-color: #eeeeee !important">
        <template v-slot:header>
          <v-text-field v-model="testataOrdine.nrDocuStampato" label="Numero" hide-details class="mr-2 pa-0"
            @click.stop.prevent ref="numOrdine" :append-icon="'search'" @click:append="cercaOrdine"
            style="max-width: 120px" :readonly="readOnlyCodeBar"></v-text-field>
          <v-text-field v-model="testataOrdine.ragioneSociale" class="pa-0" label="Cliente" hide-details readonly
            style="font-size: 12px"></v-text-field>
        </template>

        <v-card class="pa-2 ma-0 block" color="#EEEEEE">
          <v-layout row wrap>
            <v-flex xs4 pa-2>
              <v-text-field v-model="testataOrdine.dtConsRichiesta" label="Dt ordine" hide-details readonly
                style="max-width: 110px"></v-text-field>
            </v-flex>
            <v-flex xs4 pa-2>
              <v-text-field v-model="testataOrdine.dtConsConfermata" label="Dt cons." hide-details readonly
                style="max-width: 110px"></v-text-field>
            </v-flex>
            <v-flex xs4 pa-2>
              <v-text-field v-model="testataOrdine.tpConsegna" label="Tipo" hide-details readonly
                style="max-width: 110px"></v-text-field>
            </v-flex>
          </v-layout>

          <!-- Bilancia -->
          <v-layout row wrap mt-2 style="background-color: lightGrey">
            <v-flex xs4 pa-2>
              <v-btn color="success" class="ma-0" @click="pesa(false)" style="height: 58px"
                :loading="this.attesaPeso">PESA</v-btn>
            </v-flex>
            <v-flex xs4 pa-2>
              <div style="
                  border-radius: 4px;
                  height: 100%;
                  font-size: 28px;
                  padding-top: 10px;
                  text-align: center;
                ">
                {{ peso }}
              </div>
            </v-flex>
            <v-flex xs4 pa-2>
              <v-text-field v-model="carrello" class="pa-0" label="Carrello" hide-details readonly outline
                style="max-width: 100px; font-size: 12px"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- Attesa -->
    <v-progress-circular :size="50" indeterminate color="primary" v-if="attesa"
      style="display: flex; margin: 0 auto"></v-progress-circular>

    <!-- Dettaglio -->
    <v-expansion-panel flat class="has-border-bottom" v-model="panelRiferimento">
      <v-expansion-panel-content v-for="(rif, j) in getRiferimenti" :key="j">
        <template v-slot:header>
          <div>{{ rif.key + ") Rif. " + rif.values[0].rfCliente }}</div>
        </template>

        <!-- Lista articoli -->
        <articoli :itemsArticoli="getDettaglioRif(rif.values[0].nrRiferimento)" @aggiornaDati="aggiornaStatoEvasione"
          :codeBar="codeBarArticolo" :panelRiferimento="parseInt(panelRiferimento)" :tipoEvasione="'evasione'"
          v-if="panelRiferimento === j" @apriDialogDettaQta="apriDialogDettaQta"></articoli>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- Dialog dettaglio -->
    <dialogUbicazEsistenze :dialog="dialogDettQta" @chiudiDialogDettQta="chiudiDialogDettQta" :dati="rowItemDettQta">
    </dialogUbicazEsistenze>
  </div>
</template>

<script>
import {
  get_evasioneOrdine,
  get_pesoBilancia,
  set_pesoBilancia,
} from "@/api/api.js";
import Articoli from "@/components/articoli/Articoli.vue";
import dialogUbicazEsistenze from "@/components/dialog/DialogUbicazioniEsistenze.vue";

export default {
  components: {
    Articoli,
    dialogUbicazEsistenze
  },

  data() {
    return {
      panelTestata: 0,
      panelRiferimento: null,

      testataOrdine: {},

      codeBarOrdine: "",
      codeBarArticolo: {},

      dettaglioOrdine: [],

      readOnlyCodeBar: false,

      attesa: false,
      attesaPeso: false,

      peso: 0,
      carrello: "",

      dialogDettQta: false,
      rowItemDettQta: {}
    };
  },

  methods: {
    caricaDati() {
      // Reset
      this.resetDati();

      if (this.codeBarOrdine.length == 0) return;

      this.attesa = true;
      this.readOnlyCodeBar = true;

      get_evasioneOrdine(this.codeBarOrdine)
        .then((res) => {
          // Testata
          this.testataOrdine = res.data[0];

          // Memorizzo il documento letto
          this.$store.commit(
            "app/setDocumentoLetto",
            this.testataOrdine.nrDocu
          );

          this.testataOrdine.dtConsRichiesta = this.$functions.formatDate(
            new Date(this.testataOrdine.dtConsRichiesta)
          );
          this.testataOrdine.dtConsConfermata = this.$functions.formatDate(
            new Date(this.testataOrdine.dtConsConfermata)
          );

          // Dettaglio
          this.dettaglioOrdine = res.data;

          this.panelTestata = 1;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.warning(this.$functions.getErrorMsg(err));
        })
        .finally(() => {
          this.attesa = false;
          this.readOnlyCodeBar = false;
        });
    },

    resetDati() {
      // Reset
      this.testataOrdine = {};
      this.dettaglioOrdine = [];
      this.panelRiferimento = null;
      this.peso = 0;
      this.carrello = "";
    },

    cercaOrdine() {
      if (Object.keys(this.testataOrdine) == 0) {
        let ultimoNumero = this.$store.getters["app/getUltimoDocumentoLetto"];

        if (ultimoNumero) {
          this.codeBarOrdine = ultimoNumero;
        } else return;
      } else {
        this.codeBarOrdine = this.testataOrdine.nrDocuStampato;
      }

      this.caricaDati();
    },

    getDettaglioRif(nrRif) {
      return this.getDettaglio.filter((f) => f.nrRiferimento == nrRif);
    },

    aggiornaStatoEvasione(row, idUnivoco) {
      // Ricavo la riga
      let r = this.dettaglioOrdine.find((f) => f.idUnivoco == idUnivoco);

      // Viene attivata la computed getDettaglio
      r.statoEvasione = row.statoEvasione;
      r.qtEvasaStoccata = row.qtEvasaStoccata;
      r.qtRimanenza = row.qtRimanenza;
      r.parziale = row.parziale;
      r.qtaScaffale = row.qtaScaffale;
      r.qtaDaStoccare = row.qtaDaStoccare;
    },

    pesa(registra) {
      this.peso = 0;
      this.attesaPeso = true;

      let carrelloSwap = registra ? this.carrello : "";

      get_pesoBilancia(carrelloSwap)
        .then((res) => {
          this.peso = res.data;

          if (registra) this.registraPeso();
        })
        .catch((err) => {
          console.log(err);
          this.$toast.warning(this.$functions.getErrorMsg(err));
        })
        .finally(() => {
          this.attesaPeso = false;
        });
    },

    registraPeso() {
      if (Object.keys(this.testataOrdine) == 0) {
        this.$toast.warning("Ordine non valido");
        return;
      }
      if (this.peso == 0) {
        this.$toast.warning("Peso non valido");
        return;
      }

      // Messaggio di conferma
      this.$confirm
        .open("Registra", "Vuoi registrare il peso ?")
        .then((confirm) => {
          if (!confirm) return;

          this.attesaPeso = true;

          let par = {
            nrDocu: this.testataOrdine.nrDocu,
            peso: this.peso,
            utente: this.$store.getters["user/getUser"],
          };

          set_pesoBilancia(par)
            .then((res) => {
              // Reset dati
              this.resetDati();
            })
            .catch((err) => {
              console.log(err);
              this.$toast.warning(this.$functions.getErrorMsg(err));
            })
            .finally(() => {
              this.attesaPeso = false;
            });
        })
        .catch((err) => {
          console.log(this.$functions.getErrorMsg(err));
        });
    },

    apriDialogDettaQta(item) {
      this.dialogDettQta = true
      this.rowItemDettQta = item
    },
    chiudiDialogDettQta() {
      this.dialogDettQta = false
    }
  },

  mounted() { },

  computed: {
    getCodebar() {
      return this.$store.getters["app/getCodebar"];
    },

    getTipo() {
      return this.$store.getters["app/getTipo"].toLowerCase() == "evaso"
        ? 1
        : 0;
    },

    getDettaglio() {
      return this.dettaglioOrdine.filter(
        (f) => f.statoEvasione == this.getTipo
      );
    },

    getRiferimenti() {
      return this.$functions.groupByIndex(this.getDettaglio, "nrRiferimento");
    },


  },

  watch: {
    getCodebar(v) {
      // Controllo tipo ricerca
      if (this.panelRiferimento != null) {
        // --- Ricerca x articolo ---

        // NOTA: passo un json con la data x forzare la watch anche se ripasso lo stesso valore
        this.codeBarArticolo = v;
      } else {
        if (v.barcodeData.startsWith("PESO")) {
          // --- Carrello ---
          this.carrello = v.barcodeData;

          this.pesa(true);
        } else {
          // --- Ricerca x ordine ---

          this.$refs.numOrdine.focus();
          this.codeBarOrdine = v.barcodeData;

          this.caricaDati();
        }
      }
    },

    panelRiferimento() {
      //console.log("watch panelRiferimento")

      // NOTA: quando cambia pannello, resetto l'articolo selezionato
      this.$store.commit("app/resetArticoloSelezionato");
    },

    getTipo(v) {
      // NOTA: quando passo da daEvadere\evasi chiudi eventuali panel aperti
      this.panelRiferimento = null;
    },
  },
};
</script>

